
export default {
    name: 'MainContent',

    components: {
        SliderImages: () => import('~/components/object/SliderImages'),
    },

    props: {
        product: {
            type: Object,
            default: () => ({}),
        },
        images: {
            type: Array,
            default: () => [],
        },
        floorsProducts: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isOpenFloors: false,
        };
    },

    computed: {
        params() {
            let characteristics = [];
            (this.product?.characteristics || []).map((t) => {
                characteristics.push(...(t?.characteristics || []));
            });
            characteristics = characteristics.filter((t) => t.slug !== 'ssylka-na-vidzhet'); // убираем ссылку на виджет из показываемых характеристик
            characteristics = characteristics.filter((t) => t.showInProduct);
            // Смотрим наличие цены со скидкой
            const priceForMeterSale = characteristics.filter((t) => t.slug === 'cena-za-m-sale');
            // если есть скидка на метр, вырезаем из общего списка
            if (priceForMeterSale) {
              characteristics = characteristics.filter((t) => t.slug !== 'cena-za-m-sale');
            }
            characteristics = characteristics.map((characteristic) => {
                const values = (characteristic?.values || []).map((valueItem) => {
                    let value = valueItem?.value;
                    if (!priceForMeterSale && characteristic.slug === 'cena-za-m') {
                        value = `${this.$numberFormat(value)} руб`;
                    } else if (priceForMeterSale && priceForMeterSale?.[0]?.values?.[0].value && characteristic.slug === 'cena-za-m') {
                      value = {
                        price: `${this.$numberFormat(value)}`,
                        salePrice: ` ${this.$numberFormat(priceForMeterSale?.[0].values?.[0].value)} руб`,
                      };
                    }

                    return {
                        ...valueItem,
                        value,
                    };
                });

                return {
                    ...characteristic,
                    values,
                };
            });

            return characteristics;
        },

        productName() {
            return this.product?.name || '';
        },
        productTitle() {
            if (this.product?.dynamicFields?.seo_heading) {
                return this.product?.dynamicFields?.seo_heading;
            }

            const productType = this.product?.characteristicGroupId;

            if (productType === 2) {
                const rooms = this.params.find((t) => t.slug === 'rooms')?.values?.[0]?.slug;
                if (rooms === 'studiya') {
                    return 'Квартира-студия';
                }

                return `${rooms}-комнатная квартира`;
            }
            if (productType === 1) {
                return 'Машиноместо';
            }
            if (productType === 3) {
                return 'Кладовая';
            }
            if (productType === 4) {
                return 'Коммерческое помещение';
            }

            return 'Неопределенный тип объекта';
        },
        productPrice() {
            return this.product?.price || 0;
        },
        productPriceOld() {
            return this.product?.oldPrice || 0;
        },

      textTooltipHelp: function () {
          return this.$store.state?.appState?.vars?.['Подсказка к цене квартиры'] || ''
      },
    },

    methods: {
      openWidgetTour: function (link) {
        this.$emit('openWidgetTour', link)
      },

        makeRequest() {
            this.$emit('onMakeRequest');
        },
        shareProduct() {
            this.$store.commit('pop-up-share/open', {
                url: window.location.href,
                title: [this.productTitle, this.productName].filter((t) => !!t).join(' '),
            });
        },

        changeOpenFloors() {
            this.isOpenFloors = !this.isOpenFloors;
        },
    },
};
